module.exports = __webpack_public_path__ + "static/media/who-logo.d0ee6eb4.png";